import defaultPicture from '../../../../../../../assets/pngs/vehicle_default.png';
import { ExtendedListing } from '../../../../../../../models/Listing';
import { ImgProxyResizer } from '../../../../../../../utils/ImageProxyResizer';
import {
  Subtitle,
  Title,
  VehicleDataContainer,
  VehicleImage,
  VehicleInformationContainer,
} from './VehicleInformation.styles';

interface VehicleInformationProps {
  listing: ExtendedListing;
  isInitialStep?: boolean; // It has no background/border when is shown at the initial step.
}

const VehicleInformation = ({ listing, isInitialStep, ...rest }: VehicleInformationProps) => {
  const resizedEntityImage = new ImgProxyResizer(listing?.pictures?.[0]?.url).smallUrl;

  return (
    <VehicleInformationContainer $isInitialStep={isInitialStep} {...rest}>
      <VehicleImage src={listing?.pictures?.[0]?.url ? resizedEntityImage : defaultPicture} alt="Vehicle picture" />
      <VehicleDataContainer>
        <Title>{listing?.displayName}</Title>
        <Subtitle>{listing?.sharingOrganization?.name}</Subtitle>
      </VehicleDataContainer>
    </VehicleInformationContainer>
  );
};

export default VehicleInformation;
